<template>
    <div class="float-left">
        <b-button
            variant="success"
            @click="abrirModal()"
            >Adicionar
        </b-button>
        <prestacao-contas-final-lancamento-form
            operacaoProp="I"
            :convenio = "convenio"
            :prestacaoContasFinalLancamento="prestacaoContasFinalLancamento"
            :idPrestacaoMensal="idPrestacaoMensal"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
            :dataServicos="dataServicos"
        ></prestacao-contas-final-lancamento-form>
    </div>
</template>

<script>
import PrestacaoContasFinalLancamentoForm from './PrestacaoContasFinalLancamentoForm'

export default {
    components: {
        PrestacaoContasFinalLancamentoForm,
    },

    props: {
        convenio: Object,
        idPrestacaoMensal : Number,
        desativarBotao: Boolean,
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {
            mostrarModal: false,
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false,
            },
            erros: [],
            naturezas: [],
            acoes: [],

            prestacaoContasFinalLancamento: {
                codSituacao: 1,
                codTipoPrestacaoContas: 0,
                dtEmissao: null,
                dtPagamento: null,
                idAcaoConvenio: 0,
                idNaturezaDespesa: 0,
                idPrestacaoContasFinal: 0,
                idPrestacaoContasMensal: 0,
                nuConfins: 0,
                nuCsll: 0,
                nuInss: 0,
                nuIr: 0,
                nuIss: 0,
                nuPis: 0,
                nuValor: 0,
                situacao: null,
                tipoPrestacaoContas: null,
                vcDoctoPag: null,
                vcDocumento: null,
                vcFavorecido: null,
                vcObservacao: null,
                simplesNacional: true,
                lancamentoBancario: null,
            },
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },
        
        salvar(prestacaoContasFinalLancamento) {
            this.$store.dispatch('addRequest')
            let prestacaoFinal = {
                codSituacao: prestacaoContasFinalLancamento.codSituacao,
                codTipoPrestacaoContas: prestacaoContasFinalLancamento.codTipoPrestacaoContas,
                dtEmissao: this.$moment(this.prestacaoContasFinalLancamento.dtEmissao,'DD/MM/YYYY').format('YYYY-MM-DD'),
                dtPagamento: this.prestacaoContasFinalLancamento.dtPagamento != null ? this.$moment(this.prestacaoContasFinalLancamento.dtPagamento, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                idAcaoConvenio: prestacaoContasFinalLancamento.idAcaoConvenio,
                idNaturezaDespesa: prestacaoContasFinalLancamento.idNaturezaDespesa,
                idPrestacaoContasFinal: prestacaoContasFinalLancamento.idPrestacaoContasFinal,
                idPrestacaoContasMensal: this.idPrestacaoMensal,
                nuConfins: prestacaoContasFinalLancamento.nuConfins,
                nuCsll: prestacaoContasFinalLancamento.nuCsll,
                nuInss: prestacaoContasFinalLancamento.nuInss,
                nuIr: prestacaoContasFinalLancamento.nuIr,
                nuIss: prestacaoContasFinalLancamento.nuIss,
                nuPis: prestacaoContasFinalLancamento.nuPis,
                nuValor: prestacaoContasFinalLancamento.nuValor,
                situacao: prestacaoContasFinalLancamento.situacao,
                tipoPrestacaoContas: prestacaoContasFinalLancamento.tipoPrestacaoContas,
                vcDoctoPag: prestacaoContasFinalLancamento.vcDoctoPag,
                vcDocumento: prestacaoContasFinalLancamento.vcDocumento,
                vcFavorecido: prestacaoContasFinalLancamento.vcFavorecido,
                simplesNacional: prestacaoContasFinalLancamento.simplesNacional,
                lancamentoBancario: prestacaoContasFinalLancamento.lancamentoBancario,
            }
            this.dataServicos.InserirPrestacaoFinal(prestacaoFinal)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Lançamento Aplicado com sucesso',
                            'OK',
                            this.$toastConfig.success
                            
                        )
                        this.fecharModal()
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    }
}
</script>

